export default __webpack_public_path__ + "static/AeonikBold-f5ac5b02ebd8300c1f412a2f99bc2746.woff2";